module.exports = __webpack_public_path__ + "static/icon-photography-51a49fb7515adde86fea9667cba5bbaf.png";